interface ContentWrapperProps extends React.HTMLAttributes<HTMLElement> {
  fullWidth?: boolean;
  children: React.ReactNode;
  className?: string;
}
const ContentWrapper = ({
  fullWidth,
  children,
  className,
  ...props
}: ContentWrapperProps) => {
  if (fullWidth) {
    return (
      <section
        {...props}
        className={`${className ?? ""} w-full flex flex-col mx-auto  overflow-hidden`}
      >
        {children}
      </section>
    );
  }

  return (
    <section
      {...props}
      className={`${className ?? ""} w-full flex flex-col mx-auto contentContainer `}
    >
      {children}
    </section>
  );
};

export default ContentWrapper;
